import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  fmcToken: null,
};

export const LoginReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_USER_INFORMATION:
      return { ...state, ...payload };

    case ActionTypes.SET_LOGGED_IN_USER_IMAGE:
      return {
        ...state,
        [payload.role]: {
          ...state[payload.role],
          uploadedLogo: {
            ...state[payload.role].uploadedLogo,
            filePath: payload.profileImage,
          },
          firstName: payload.firstName,
          lastName: payload.lastName,
        },
      };

    case ActionTypes.SET_SCHOOL_NAME:
      return {
        ...state,
        school: {
          ...state.school,
          schoolName: payload,
        },
      };

    case ActionTypes.SET_WEEK_LIST:
      return {
        ...state,
        weekList: payload,
      };

    case ActionTypes.SET_OPPONENT_SCHOOL_LIST:
      return {
        ...state,
        schoolList: payload,
      };

    case ActionTypes.SET_FORM_HOOK:
      return {
        ...state,
        formHook: payload,
      };

    case ActionTypes.TOGGLE_BUILD_SCHEDULE_POPUP:
      return {
        ...state,
        buildSchedulePopup: payload,
      };

    case ActionTypes.SET_CURRENT_SEASON:
      return {
        ...state,
        currentSeason: payload,
      };

    case ActionTypes.SET_EDIT_SCHEDULE:
      return {
        ...state,
        isEditSchedule: payload,
      };

    case ActionTypes.SET_SCHEDULE_INFORMATION:
      return {
        ...state,
        scheduleInformation: payload,
      };

    case ActionTypes.SET_CURRENT_SEASON_IN_USER_PROFILE:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          currentSeason: payload,
        },
      };

    case ActionTypes.ADD_FMC_TOKEN:
      return {
        ...state,
        fmcToken: payload,
      };
    default:
      return state;
  }
};
